import {
  AllYouCanEatType,
  HistoryFlagType,
  IDispCondGroup,
  IDispCondMenu,
  IMenuItemInfo,
  IOrderDetail,
  MenuBookGroupInfoType,
} from 'apis/types';
import { MENU_DISPLAY_CONDITION } from 'constants/menuTiming';
import i18n from 'translation/i18n';
import { attrLang } from './attrLang';
import { EOS_MESSAGE } from '../constants';

interface OrderHistoryMenuNode {
  MenuCode: string;
  MenuInfo?: OrderHistoryMenuNode[];
}

export function getErrorMessage(
  modeCode: string,
  isLunchTime: boolean,
  historyFlag: HistoryFlagType,
  allYouCanEatState: AllYouCanEatType,
  menuData: IMenuItemInfo,
  currentMenubook: MenuBookGroupInfoType,
  outOfStocked: boolean,
  eosFlg: string,
  haveAdult: number,
  dispcondMenu?: IDispCondMenu,
  dispcondgroup?: IDispCondGroup,
  orderHistory?: IOrderDetail[],
  isItemShinagire?: boolean
): string {
  if (!menuData) return '';
  const { t } = i18n;
  let message = '';
  const displayCond = menuData.dispcond;

  if (isItemShinagire && eosFlg === '1') {
    return EOS_MESSAGE;
  } else if (outOfStocked) {
    message = t('MenuList.out_of_stock');
  } else if (menuData.callstaff_flg === '1' || (menuData.agelimit_flg === '1' && haveAdult === 0)) {
    message = t('MenuList.call_staff');
  } else {
    switch (displayCond) {
      case MENU_DISPLAY_CONDITION.DISPLAY_GROUP_CONTROL: {
        const groupNames: string[] = [];
        if (dispcondMenu && orderHistory && dispcondgroup) {
          for (const dispcondGroupCode of menuData.dispcond_group) {
            if (isPreviousOrderGroupSatisfied(dispcondGroupCode, dispcondMenu, orderHistory) == false) {
              groupNames.push(`「${attrLang(dispcondgroup[dispcondGroupCode], 'lang')}」`);
            }
          }
        }
        const messageTmp: string = t('MenuItemDetail.display_group_control_order', {
          groupName: groupNames.join('<br/>'),
        });
        if (groupNames.length > 0) message = messageTmp;
        break;
      }
      default: {
        break;
      }
    }
  }

  //check if menu in all-you-can-eat
  if (currentMenubook.course) {
    if (!allYouCanEatState.isShowEatRemainTime && menuData.th_bunruicd === '01') {
      message = t('AllYouCanEat.menu_not_available');
    } else if (!allYouCanEatState.isShowDrinkRemainTime && menuData.th_bunruicd === '02') {
      message = t('AllYouCanEat.menu_not_available');
    }
  }

  return message;
}

export function isPreviousOrderGroupSatisfied(
  dispcondGroupCode: string,
  dispcondMenu: IDispCondMenu,
  orderHistory: IOrderDetail[]
): boolean {
  const menuCodes = dispcondMenu[dispcondGroupCode] || [];
  return menuCodes.some((menuCode) => hasMenuCodeInOrderHistory(menuCode, orderHistory));
}

function containsMenuCode(menuCode: string, menuItems: OrderHistoryMenuNode[]): boolean {
  for (const item of menuItems) {
    if (item.MenuCode === menuCode) {
      return true;
    }
    if (item.MenuInfo && Array.isArray(item.MenuInfo)) {
      const found = containsMenuCode(menuCode, item.MenuInfo);
      if (found) {
        return true;
      }
    }
  }
  return false;
}

export function hasMenuCodeInOrderHistory(menuCode: string, orderHistory: IOrderDetail[]): boolean {
  for (const historyOrder of orderHistory) {
    const orderStates = historyOrder.OrderDetailMenuInfo;
    if (containsMenuCode(menuCode, orderStates)) {
      return true;
    }
  }
  return false;
}
